import { render, staticRenderFns } from "./purAPStat.vue?vue&type=template&id=41154c67&scoped=true&"
import script from "./purAPStat.vue?vue&type=script&lang=js&"
export * from "./purAPStat.vue?vue&type=script&lang=js&"
import style0 from "./purAPStat.vue?vue&type=style&index=0&id=41154c67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41154c67",
  null
  
)

component.options.__file = "purAPStat.vue"
export default component.exports